const tables = [
  {
    name: "Title",
  },
  {
    name: "Status",
  },
  {
    name: "Action",
  },
];

export default tables;
